import styled from "styled-components";

interface IContainerProps {
  criare?: boolean;
  italinea?: boolean;
}

export const Container = styled.button<IContainerProps>`
  width: 19rem;
  height: 6.2rem;

  text-align: center;
  font-family: "Galano";
  font-weight: 300;
  font-size: 2rem;
  line-height: 2.3rem;
  letter-spacing: 0.17rem;
  @media (max-width: 1200px) {
    text-align: left;
    height: fit-content;
    padding: 1.5rem 0;
  }
`;
